import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useLearning } from 'src/hook/data/useLearning';
import { Chl } from 'src/model/Scenario';
import { GetPeopleImageUrl } from 'src/utils/URLUtils';
import styles from './SubItem.module.scss';
interface SubItemProps {
    challenge: Chl;
    scenarioRef: string;
}

const SubItem = ({ challenge, scenarioRef }: SubItemProps) => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const { learningInfo } = useLearning();
    const isCompleted = useMemo(() => {
        return learningInfo?.Scenarios.CompletedContext.includes(scenarioRef)
            || learningInfo?.Scenarios.Challenges.includes(`${scenarioRef}${challenge.ref}`);
    }, [learningInfo?.Scenarios, scenarioRef, challenge.ref]);

    const handleClick = () => {
        navigate(`/scenario/description/?id=${scenarioRef}&index=${challenge.ref}`);
    };

    return (
        <div className={styles.container}>

            <div className={styles.titleContainer}>
                <span className={styles.number}>
                    {challenge.ref}
                </span>
                <h3 className={styles.title}>
                    {challenge.t}
                </h3>
            </div>
            <p className={styles.description}>
                {challenge.b}
            </p>

            <div className={styles.gridContainer}>
                <div className={styles.leftTop}>
                    {challenge.d.length > 50
                        ? `${challenge.d.substring(0, 50)}...`
                        : challenge.d}
                </div>
                <div className={styles.leftBottom}>
                    {isCompleted ?
                        <p className={styles.completed} onClick={handleClick}>  {t('Completed')} ✓ </p>
                        : <button className={styles.selectButton} onClick={handleClick}>
                            {t('Select')}
                        </button>}
                </div>
                <div className={styles.right}>
                    <img
                        src={GetPeopleImageUrl(challenge.n)}
                        alt={challenge.n}
                        className={styles.image}
                    />
                </div>
            </div>
        </div>
    );
};

export default SubItem;
